import { get, post } from "@/utils/utils";

const goodsLib = {
  state: {
    goodsCategoryList: {},
    addGoodsCategoryCode: "",
    goodsCategoryDetails: {},
    editGoodsCategoryCode: "",
    goodsCategoryTree: [],
    allBrandActivityList: {},
    brandDetail: {},
    brandEdit: {},
    brandDelCode: "",
    allBrandList: {},
    addAttributeCode: "",
    editAttributeCode: "",
    attributeList: {},
    attributeDetails: {},
    allAttributeList: {},
    attributeEditDetails: {},
    deleteAttrubuteCode: "",
    specificationDetails: {},
    specificationEditDetails: {},
    specificationList: {},
    allSpecificationList: {},
    specList: [],
    attrList: [],
    supplierList: [],
    salesChannels: [],
    mallGoodsList: [],
    allMallGoodsList: [],
    goodsDetails: {},
    goodsBaseInfo: {}
  },
  mutations: {
    QUERY_DELIVERY_METHOD() {},
    QUERY_GOOD_CATEGORY_LIST(state, data) {
      state.goodsCategoryList = data.result;
      if (
        state.goodsCategoryList.records &&
        state.goodsCategoryList.records.length
      ) {
        state.goodsCategoryList.records.forEach(v => {
          v.hasChildren = Boolean(v.isChild);
        });
      }
    },
    QUERY_GOOD_CATEGORY_LIST_BY_PARENT(state, data) {
      state.goods = data.result;
    },
    ADD_GOODS_CATEGORY(state, data) {
      state.addGoodsCategoryCode = data.code;
    },
    QUERY_GOODS_CATEGORY_DETAILS(state, data) {
      state.goodsCategoryDetails = data.result;
    },
    EDIT_GOODS_CATEGORY(state, data) {
      state.editGoodsCategoryCode = data.result;
    },
    QUERY_GOODS_CATEGORY_TREE(state, data) {
      state.goodsCategoryTree = data.result;
      if (state.goodsCategoryTree && state.goodsCategoryTree.length) {
        state.goodsCategoryTree.forEach(v => {
          v.leaf = Boolean(!v.isChild);
        });
      }
    },
    DELETE_GOODS_CATEGORY(state, data) {
      state.deleteCode = data.code;
    },
    QUERY_ALL_BRAND_LIST(state, data) {
      state.allBrandList = data.result;
    },
    BRAND_EDIT(state, data) {
      state.brandEdit = data.result;
    },
    ALL_BRAND_LIST(state, data) {
      state.allBrandActivityList = data.result;
    },
    BRAND_DETAIL(state, data) {
      state.brandDetail = data.result;
    },
    BRAND_DEL(state, data) {
      state.brandDelCode = data.code;
    },
    ADD_BRAND() {},
    ADD_ATTRIBUTE(state, data) {
      state.addAttributeCode = data.code;
    },
    EDIT_ATTRIBUTE(state, data) {
      state.editAttributeCode = data.code;
    },
    QUERY_ATTRIBUTE_DETAILS(state, data) {
      state.attributeDetails = data.result;
    },
    QUERY_ATTRIBUTE_EDIT_DETAILS(state, data) {
      state.attributeEditDetails = data.result;
    },
    QUERY_ATTRIBUTE_LIST(state, data) {
      state.attributeList = data.result;
    },
    DELETE_ATTRIBUTE(state, data) {
      state.deleteAttrubuteCode = data.result;
    },
    QUERY_ALL_ATTRIBUTE_LIST(state, data) {
      state.allAttributeList = data.result.records;
    },
    ADD_SPECIFICATION(state, data) {
      state.addSpecificationCode = data.code;
    },
    EDIT_SPECIFICATION(state, data) {
      state.editSpecificationCode = data.code;
    },
    QUERY_SPECIFICATION_DETAILS(state, data) {
      state.specificationDetails = data.result;
    },
    QUERY_SPECIFICATION_EDIT_DETAILS(state, data) {
      state.specificationEditDetails = data.result;
    },
    QUERY_SPECIFICATION_LiST(state, data) {
      state.specificationList = data.result;
    },
    DELETE_SPECIFICATION(state, data) {
      state.deleteSpecificaitonCode = data.code;
    },
    QUERY_ALL_SPECIFICATION_LIST(state, data) {
      state.allSpecificationList = data.result.records;
    },
    ADD_GOODS(state, data) {
      state.addGoodsCode = data.code;
    },
    EDIT_GOODS(state, data) {
      state.editGoodsCode = data.code;
    },
    DELETE_GOODS(state, data) {
      state.deleteGoodsCode = data.code;
    },
    QUERY_GOODS_LIST(state, data) {
      state.mallGoodsList = data.result;
    },
    QUERY_GOODS_DETAILS(state, data) {
      state.goodsDetails = data.result;
    },
    QUERY_ALL_GOODS_LIST(state, data) {
      state.allMallGoodsList = data.result.records;
    },
    QUERY_SPEC_LIST_BY_ADD_GOODS(state, data) {
      state.specList = data.result;
    },
    QUERY_ATTR_LIST_BY_ADD_GOODS(state, data) {
      state.attrList = data.result;
    },
    QUERY_SUPPLIER_LIST(state, data) {
      state.supplierList = data.result;
    },
    QUERY_SALES_CHANNELS(state, data) {
      state.salesChannels = data.result;
    },
    BATCH_EDIT(state, data) {
      state.batchEditCode = data.code;
    },
    IMPORT_BRAND() {},
    IMPORT_GOODS() {},
    QUERY_SPIDER_IMG() {},
    QUERY_WX_SHOP_SPU_POST_MESSAGE() {},
    ADD_GOODS_GROUP() {},
    EDIT_GOODS_GROUP() {},
    QUERY_GOODS_GROUP_LIST() {},
    DELETE_GOODS_GROUP() {},
    QUERY_GOODS_GROUP_DETAILS() {},
    QUERY_DELIVERY_LIMIT() {},
    ADD_GOODS_BASE_INFO() {},
    EDIT_GOODS_BASE_INFO() {},
    REMOVE_GOODS_BASE_INFO() {},
    QUERY_GOODS_BASE_INFO() {},
    ADD_STORE_SYSTEMPARAMINFO() {},
    EDIT_STORE_SYSTEMPARAMINFO() {},
    GET_PARAMVALUEALLOWNULL() {},
    GET_PARAMVALUEALLOWNULLNOTOKEN() {},
    PROCWXSHOP_HOTSALESGOODSJOB() {},
    QUERY_GOODS_BASE_INFO_DETAILS() {},
    SET_BASE_INFO(state, data) {
      state.goodsBaseInfo = data;
    },
    GET_WX_GOODS_CATEGORY() {},
    WX_SHOP_SPU_ADD() {},
    QUERY_SALE_ANALYSIS() {},
    QUERY_FLOW_ANALYSIS() {},
    QUERY_SKU_SALE_ANALYSIS() {},
    QUERY_REQURCHASE_ANALYSIS() {},
    QUERY_SPUTO_ANALYSIS() {},
    QUERY_SPU_FROM_ANALYSIS() {},
    SHOP_AUDIT_CATEGORY() {},
    GET_WECHAT_CATEGORY() {},
    ADD_BATCH_UPDATE_RECORD() {},
    QUERY_BATCH_UPDATE_RECORD_LIST() {},
    QUERY_BATCH_UPDATE_RECORD_BY_ID() {},
    AUDIT_BATCH_UPDATE_RECORD() {},
    WECHAT_SHOP_SPU_EDIT() {},
    WECHAT_SHOP_SPU_GET(){},
    EDIT_SPU_SHARE_STATE(){},
    ADD_SPU_CHECK_REPEAT_SPEC_BARCODE() {},
    EDIT_SPU_CHECK_REPEAT_SPEC_BARCODE() {},
    GEN_NEW_UNIQUES_SU_BARCODE() {},
    ADD_SPEC_VALUE() {},
  },
  actions: {
    addGoodsBaseInfo({ commit }, params) {
      return post({
        commit,
        url: `/basic/spurichtext/add`,
        name: "ADD_GOODS_BASE_INFO",
        params
      });
    },
    editGoodsBaseInfo({ commit }, params) {
      return post({
        commit,
        url: `/basic/spurichtext/edit`,
        name: "EDIT_GOODS_BASE_INFO",
        params
      });
    },
    removeGoodsBaseInfo({ commit }, params) {
      return post({
        commit,
        url: `/basic/spurichtext/remove`,
        name: "REMOVE_GOODS_BASE_INFO",
        params
      });
    },
    // 公用方法（参数新增、编辑、读取）
    addStoreSystemParamInfo({ commit }, params) {
      return post({
        commit,
        url: `/storepermissions/storeSystemParamInfo/add`,
        name: "ADD_STORE_SYSTEMPARAMINFO",
        params
      });
    },
    // 公用方法（参数新增、编辑、读取）
    editStoreSystemParamInfo({ commit }, params) {
      return post({
        commit,
        url: `/storepermissions/storeSystemParamInfo/editValueById`,
        name: "EDIT_STORE_SYSTEMPARAMINFO",
        params
      });
    },
    // 公用方法（参数新增、编辑、读取）
    getModelByParamCode({ commit }, params) {
      return post({
        commit,
        url: `/storepermissions/storeSystemParamInfo/getModelByParamCode`,
        name: "GET_PARAMVALUEALLOWNULL",
        params
      });
    },
    // 公用方法（参数新增、编辑、读取）
    getModelAllowNullNoToken({ commit }, params) {
      return post({
        commit,
        url: `/storepermissions/storeSystemParamInfo/getModelAllowNullNoToken`,
        name: "GET_PARAMVALUEALLOWNULLNOTOKEN",
        params
      });
    },
    procWxshopHotSalesGoodsJob({ commit }, params) {
      return post({
        commit,
        url: `/provider/goods/micro/ranking/wxshopHotSalesGoodsConfig/procWxshopHotSalesGoodsJob`,
        name: "PROCWXSHOP_HOTSALESGOODSJOB",
        params
      });
    },
    queryGoodsBaseInfo({ commit }, params) {
      return post({
        commit,
        url: `/basic/spurichtext/list`,
        name: "QUERY_GOODS_BASE_INFO",
        params
      });
    },
    queryGoodsBaseInfoDetails({ commit }, params) {
      return post({
        commit,
        url: `/basic/spurichtext/detail`,
        name: "QUERY_GOODS_BASE_INFO_DETAILS",
        params
      });
    },
    addGoodsGroup({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu_group/add`,
        name: "ADD_GOODS_GROUP",
        params
      });
    },
    queryGoodsGropDetails({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu_group/detail_list`,
        name: "QUERY_GOODS_GROUP_DETAILS",
        params
      });
    },
    deleteGoodsGrop({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu_group/delete`,
        name: "DELETE_GOODS_GROUP",
        params
      });
    },
    queryGoodsGroupList({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu_group/list`,
        name: "QUERY_GOODS_GROUP_LIST",
        params
      });
    },
    editGoodsGroup({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu_group/edit`,
        name: "EDIT_GOODS_GROUP",
        params
      });
    },
    queryWxShopSpuPostMessage({ commit }, params) {
      return post({
        commit,
        url: `/sys/wxshop_spu_post_message`,
        name: "QUERY_WX_SHOP_SPU_POST_MESSAGE",
        params
      });
    },
    queryMemberLimit({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeGroupInfo/list`,
        name: "QUERY_DELIVERY_LIMIT",
        params
      });
    },
    queryDeliveryMethod({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=express_mode`,
        name: "QUERY_DELIVERY_METHOD",
        params
      });
    },
    querySpiderImg({ commit }, params) {
      return get({
        commit,
        url: `/basic/spu/spider_img_list`,
        name: "QUERY_SPIDER_IMG",
        params
      });
    },
    batchEdit({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/batch_edit`,
        name: "BATCH_EDIT",
        params
      });
    },
    importBrand({ commit }, params) {
      return post({
        commit,
        url: `/basic/brand/import`,
        name: "IMPORT_BRAND",
        params
      });
    },
    importGoods({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/import`,
        name: "IMPORT_GOODS",
        params
      });
    },
    deleteGoods({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/del`,
        name: "DELETE_GOODS",
        params
      });
    },
    queryGoodsDetails({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/detail`,
        name: "QUERY_GOODS_DETAILS",
        params
      });
    },
    querySalesChannels({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/platform_list`,
        name: "QUERY_SALES_CHANNELS",
        params
      });
    },
    querySupplierList({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/supplier_list`,
        name: "QUERY_SUPPLIER_LIST",
        params
      });
    },
    queryAttrListByAddGoods({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/add_spu_attr_list`,
        name: "QUERY_ATTR_LIST_BY_ADD_GOODS",
        params
      });
    },
    querySpecListByAddGoods({ commit }, params) {
      return post({
        commit,
        url: `/basic/spec/add_spu_spec_list`,
        name: "QUERY_SPEC_LIST_BY_ADD_GOODS",
        params
      });
    },
    addGoods({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/add`,
        name: "ADD_GOODS",
        params
      });
    },
    editGoods({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/edit`,
        name: "EDIT_GOODS",
        params
      });
    },
    queryMallGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/list`,
        name: "QUERY_GOODS_LIST",
        params
      });
    },
    queryAllMallGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/list`,
        name: "QUERY_ALL_GOODS_LIST",
        params
      });
    },
    //新增属性
    addAttribute({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/add`,
        name: "ADD_ATTRIBUTE",
        params
      });
    },
    deleteAttribute({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/del`,
        name: "DELETE_ATTRIBUTE",
        params
      });
    },
    //属性详情
    queryAttributeDetails({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/detail`,
        name: "QUERY_ATTRIBUTE_DETAILS",
        params
      });
    },
    //属性详情
    queryAttributeEditDetails({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/to_edit`,
        name: "QUERY_ATTRIBUTE_EDIT_DETAILS",
        params
      });
    },
    editAttribute({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/edit`,
        name: "EDIT_ATTRIBUTE",
        params
      });
    },
    queryAttributeList({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/list`,
        name: "QUERY_ATTRIBUTE_LIST",
        params
      });
    },
    queryAllAttributeList({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/list`,
        name: "QUERY_ALL_ATTRIBUTE_LIST",
        params
      });
    },
    //新增属性
    addSpecification({ commit }, params) {
      return post({
        commit,
        url: `/basic/spec/add`,
        name: "ADD_SPECIFICATION",
        params
      });
    },
    deleteSpecification({ commit }, params) {
      return post({
        commit,
        url: `/basic/spec/del`,
        name: "DELETE_SPECIFICATION",
        params
      });
    },
    querySpecificationDetails({ commit }, params) {
      return post({
        commit,
        url: `/basic/spec/detail`,
        name: "QUERY_SPECIFICATION_DETAILS",
        params
      });
    },
    querySpecificationEditDetails({ commit }, params) {
      return post({
        commit,
        url: `/basic/spec/to_edit`,
        name: "QUERY_SPECIFICATION_EDIT_DETAILS",
        params
      });
    },
    editSpecification({ commit }, params) {
      return post({
        commit,
        url: `/basic/spec/edit`,
        name: "EDIT_SPECIFICATION",
        params
      });
    },
    querySpecificationList({ commit }, params) {
      return post({
        commit,
        url: `/basic/spec/list`,
        name: "QUERY_SPECIFICATION_LiST",
        params
      });
    },
    queryAllSpecificationList({ commit }, params) {
      return post({
        commit,
        url: `/basic/spec/list`,
        name: "QUERY_ALL_SPECIFICATION_LIST",
        params
      });
    },
    //查询品牌导出
    queryBrandAllList({ commit }, params) {
      return post({
        commit,
        url: `/basic/brand/basic_list${params.loading ? "?false" : ""}`,
        name: "QUERY_ALL_BRAND_LIST",
        params
      });
    },
    //删除品牌
    delBrand({ commit }, params) {
      return post({
        commit,
        url: `/basic/brand/del`,
        name: "BRAND_DEL",
        params
      });
    },
    //编辑品牌
    queryBrandEdit({ commit }, params) {
      return post({
        commit,
        url: `/basic/brand/edit`,
        name: "BRAND_EDIT",
        params
      });
    },
    //品牌详情
    queryBrandDetail({ commit }, params) {
      return post({
        commit,
        url: `/basic/brand/detail`,
        name: "BRAND_DETAIL",
        params
      });
    },
    //品牌列表
    queryBrandActivityList({ commit }, params) {
      return post({
        commit,
        url: `/basic/brand/basic_list`,
        name: "ALL_BRAND_LIST",
        params
      });
    },
    //新增品牌
    addBrandActivity({ commit }, params) {
      return post({
        commit,
        url: `/basic/brand/add`,
        name: "ADD_BRAND",
        params
      });
    },
    queryGoodsCategoryListByParent({ commit }, params) {
      return post({
        commit,
        url: `/basic/category/basic_list`,
        name: "QUERY_GOOD_CATEGORY_LIST_BY_PARENT",
        params
      });
    },
    queryGoodsCategoryList({ commit }, params) {
      return post({
        commit,
        url: `/basic/category/basic_list`,
        name: "QUERY_GOOD_CATEGORY_LIST",
        params
      });
    },
    deleteGoodsCategory({ commit }, params) {
      return post({
        commit,
        url: `/basic/category/del`,
        name: "DELETE_GOODS_CATEGORY",
        params
      });
    },
    addGoodsCategory({ commit }, params) {
      return post({
        commit,
        url: `/basic/category/add`,
        name: "ADD_GOODS_CATEGORY",
        params
      });
    },
    queryGoodsCategoryDetails({ commit }, params) {
      return post({
        commit,
        url: `/basic/category/detail`,
        name: "QUERY_GOODS_CATEGORY_DETAILS",
        params
      });
    },
    editGoodsCategory({ commit }, params) {
      return post({
        commit,
        url: `/basic/category/edit`,
        name: "EDIT_GOODS_CATEGORY",
        params
      });
    },
    queryGoodsCategoryTree({ commit }, params) {
      return post({
        commit,
        url: `/basic/category/tree`,
        name: "QUERY_GOODS_CATEGORY_TREE",
        params
      });
    },
    getWeChatShopCategory({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/getWeChatShopCategory`,
        name: "GET_WX_GOODS_CATEGORY",
        params
      });
    },
    weChatShopSpuEdit({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/weChatShopSpuEdit`,
        name: "WECHAT_SHOP_SPU_EDIT",
        params
      });
    },
    weChatShopSpuGet({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/weChatShopSpuGet`,
        name: "WECHAT_SHOP_SPU_GET",
        params
      });
    },
    weChatShopSpuAdd({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/weChatShopSpuAdd`,
        name: "WX_SHOP_SPU_ADD",
        params
      });
    },
    shopAuditCategory({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/shopAuditCategory`,
        name: "SHOP_AUDIT_CATEGORY",
        params
      });
    },
    getWeChatShopCategoryList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/getWeChatShopCategoryList`,
        name: "GET_WECHAT_CATEGORY",
        params
      });
    },
    editSpuShareState({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/editSpuShareState`,
        name: "EDIT_SPU_SHARE_STATE",
        params
      });
    },    
    querySaleAnalysis({ commit }, params) {
      return post({
        commit,
        url: `/wxshopSpu/statistics/querySaleAnalysis`,
        name: "QUERY_SALE_ANALYSIS",
        params
      });
    },
    queryFlowAnalysis({ commit }, params) {
      return post({
        commit,
        url: `/wxshopSpu/statistics/queryFlowAnalysis`,
        name: "QUERY_FLOW_ANALYSIS",
        params
      });
    },
    querySkuSaleAnalysis({ commit }, params) {
      return post({
        commit,
        url: `/wxshopSpu/statistics/querySkuSaleAnalysis`,
        name: "QUERY_SKU_SALE_ANALYSIS",
        params
      });
    },
    queryRepurchaseAnalysis({ commit }, params) {
      return post({
        commit,
        url: `/wxshopSpu/statistics/queryRepurchaseAnalysis`,
        name: "QUERY_REQURCHASE_ANALYSIS",
        params
      });
    },
    querySpuToAnalysis({ commit }, params) {
      return post({
        commit,
        url: `/wxshopSpu/statistics/querySpuToAnalysis`,
        name: "QUERY_SPUTO_ANALYSIS",
        params
      });
    },
    querySpuFromAnalysis({ commit }, params) {
      return post({
        commit,
        url: `/wxshopSpu/statistics/querySpuFromAnalysis`,
        name: "QUERY_SPU_FROM_ANALYSIS",
        params
      });
    },
    addBatchUpdateRecord({ commit }, params) {
      return post({
        commit,
        url: `/wxshop/wxshopSpuBatchUpdateRecord/add`,
        name: "ADD_BATCH_UPDATE_RECORD",
        params
      });
    },
    queryBatchUpdateRecordList({ commit }, params) {
      return post({
        commit,
        url: `/wxshop/wxshopSpuBatchUpdateRecord/queryPageList`,
        name: "QUERY_BATCH_UPDATE_RECORD_LIST",
        params
      });
    },
    queryBatchUpdateRecordById({ commit }, params) {
      return post({
        commit,
        url: `/wxshop/wxshopSpuBatchUpdateRecord/queryById`,
        name: "QUERY_BATCH_UPDATE_RECORD_BY_ID",
        params
      });
    },
    auditBatchUpdateRecord({ commit }, params) {
      return post({
        commit,
        url: `/wxshop/wxshopSpuBatchUpdateRecord/audit`,
        name: "AUDIT_BATCH_UPDATE_RECORD",
        params
      });
    },
    addSpuCheckRepeatSpecBarcode({ commit }, params) {
      return post({
        commit,
        url: `/storeSkuInfo/addSpuCheckRepeatSpecBarcode`,
        name: "ADD_SPU_CHECK_REPEAT_SPEC_BARCODE",
        params
      });
    },
    editSpuCheckRepeatSpecBarcode({ commit }, params) {
      return post({
        commit,
        url: `/storeSkuInfo/editSpuCheckRepeatSpecBarcode`,
        name: "EDIT_SPU_CHECK_REPEAT_SPEC_BARCODE",
        params
      });
    },
    genNewUniquesSuBarcode({ commit }, params) {
      return post({
        commit,
        url: `/provider/goods/storeSku/genNewUniquesSuBarcode`,
        name: "GEN_NEW_UNIQUES_SU_BARCODE",
        params
      });
    },
    addSpecValue({ commit }, params) {
      return post({
        commit,
        url: `/basic/spec/addSpecValue`,
        name: "ADD_SPEC_VALUE",
        params
      });
    },
  }
};

export default goodsLib;
